import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import AuthShell from "./AuthShell";

const Register = () => {
  const [passState, setPassState] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const handleFormSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      navigate(`${process.env.PUBLIC_URL}/auth-success`);
    }, 1000);
  };
  return (
    <AuthShell
      title="Register"
      heading="Create your account"
      subheading="Set up access to the ProcureX platform."
      footNote={
        <>
          Already have an account? <Link to={`/`}>Sign in instead</Link>
        </>
      }
    >
      <form
        className="pxauth-form"
        noValidate
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <div className="pxauth-field">
          <div className="pxauth-labelRow">
            <label className="pxauth-label" htmlFor="pxauth-name">
              Name
            </label>
          </div>
          <div className="pxauth-control">
            <input
              id="pxauth-name"
              type="text"
              autoComplete="name"
              placeholder="Enter your name"
              className={`pxauth-input${errors.name ? " is-invalid" : ""}`}
              aria-invalid={!!errors.name}
              aria-describedby={errors.name ? "pxauth-name-error" : undefined}
              {...register("name", { required: true })}
            />
          </div>
          {errors.name && (
            <p className="pxauth-error" id="pxauth-name-error" role="alert">
              This field is required
            </p>
          )}
        </div>

        <div className="pxauth-field">
          <div className="pxauth-labelRow">
            <label className="pxauth-label" htmlFor="pxauth-email">
              Email or username
            </label>
          </div>
          <div className="pxauth-control">
            <input
              id="pxauth-email"
              type="text"
              autoComplete="username"
              placeholder="Enter your email address or username"
              className={`pxauth-input${errors.email ? " is-invalid" : ""}`}
              aria-invalid={!!errors.email}
              aria-describedby={errors.email ? "pxauth-email-error" : undefined}
              {...register("email", { required: true })}
            />
          </div>
          {errors.email && (
            <p className="pxauth-error" id="pxauth-email-error" role="alert">
              This field is required
            </p>
          )}
        </div>

        <div className="pxauth-field">
          <div className="pxauth-labelRow">
            <label className="pxauth-label" htmlFor="pxauth-passcode">
              Passcode
            </label>
          </div>
          <div className="pxauth-control pxauth-control--password">
            <input
              id="pxauth-passcode"
              type={passState ? "text" : "password"}
              autoComplete="new-password"
              placeholder="Enter your passcode"
              className={`pxauth-input${errors.passcode ? " is-invalid" : ""}`}
              aria-invalid={!!errors.passcode}
              aria-describedby={
                errors.passcode ? "pxauth-passcode-error" : undefined
              }
              {...register("passcode", { required: "This field is required" })}
            />
            <button
              type="button"
              className="pxauth-reveal"
              aria-label={passState ? "Hide passcode" : "Show passcode"}
              aria-pressed={passState}
              aria-controls="pxauth-passcode"
              onClick={() => setPassState((prev) => !prev)}
            >
              {passState ? (
                <EyeInvisibleOutlined aria-hidden="true" />
              ) : (
                <EyeOutlined aria-hidden="true" />
              )}
            </button>
          </div>
          {errors.passcode && (
            <p className="pxauth-error" id="pxauth-passcode-error" role="alert">
              {errors.passcode.message}
            </p>
          )}
        </div>

        <button type="submit" className="pxauth-btn" disabled={loading}>
          {loading ? (
            <>
              <span className="pxauth-spinner" aria-hidden="true" />
              Registering&hellip;
            </>
          ) : (
            "Register"
          )}
        </button>
      </form>
    </AuthShell>
  );
};
export default Register;
